import { styled } from '@linaria/react'
import { COLLECTION_GAPS, GRID, LAYOUT } from 'vars/index'

export const SearchGridSkeletonInnerSC = styled.div<{
  rowGap: COLLECTION_GAPS
  columnGap: COLLECTION_GAPS
  totalRows: number
  cardCount: number
  cardsAspectRatio: number
}>`
  --rowGap: ${({ rowGap }) => `var(${rowGap})`};
  --columnGap: ${({ columnGap }) => `var(${columnGap})`};
  --totalRows: ${({ totalRows }) => totalRows};
  --cardsCount: ${({ cardCount }) => cardCount};
  --heaghtCard: ${({ cardsAspectRatio }) =>
    `calc(var(--cardWidth) / ${cardsAspectRatio})`};
  --cardWidth: calc(
    (
        100vw - var(${LAYOUT.HorizontalPaddings}) * 2 -
          (var(--cardsCount) - 1) * var(--rowGap)
      ) /
      var(--cardsCount)
  );

  padding: 0 var(${LAYOUT.HorizontalPaddings})
    var(${GRID.VerticalPaddingsSearchPage}) var(${LAYOUT.HorizontalPaddings});
`

export const SearchGridSkeletonTitleSC = styled.div`
  width: var(--cardWidth);
  background-color: var(--componentsBGColor);
  margin-bottom: var(${COLLECTION_GAPS.GRID_GAP_SEARCH_HORIZONTAL});
  height: 28px;
  border-radius: 8px;
`

export const SearchGridSkeletonSC = styled.div`
  display: grid;
  grid-template-columns: repeat(var(--cardsCount), var(--cardWidth));
  grid-template-rows: auto;
  grid-gap: var(--rowGap) var(--columnGap);
  height: 100%;
  flex: 0 0 auto;

  & > * {
    background-color: var(--componentsBGColor);
    width: var(--cardWidth);
    height: var(--heaghtCard);
    border-radius: 4px;
  }
`
